import { useState } from "react";

import { ReactComponent as ParcelBox } from "assets/images/icons/ParcelBox.svg";
import { ProviderOption } from "@RequestFormV2/sections/Provider/types";

interface ProviderHeaderAvatarProps {
  provider: ProviderOption;
}

export default function ProviderHeaderAvatar({ provider }: ProviderHeaderAvatarProps) {
  const [logoError, setLogoError] = useState(false);
  const logoUrl = typeof provider.company_logo === "string" ? provider.company_logo : "";

  return (
    <div className="rfv2-header__avatar">
      {logoUrl && !logoError ? (
        <img
          src={logoUrl}
          alt={provider.company_name}
          width={32}
          height={32}
          onError={() => setLogoError(true)}
        />
      ) : (
        <span className="rfv2-header__avatar-fallback">
          <ParcelBox />
        </span>
      )}
    </div>
  );
}
